/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 22:03:16 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 16:08:27
 * @Todo: 四张图片
 */

<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.wherePosts.h1') }}</h1>
      <h2>{{ st('helpDocs.wherePosts.h2') }}</h2>
      <ul>
        <li>{{ st('helpDocs.wherePosts.li1') }}</li>
        <li>{{ st('helpDocs.wherePosts.li2') }}</li>
      </ul>
      <p>{{ st('helpDocs.wherePosts.pExample') }}</p>
      <div class="flex">
        <img
          src="about-artemisads/where-will-promotion-posts-be-displayed-01.png"
          :alt="st('helpDocs.wherePosts.imgAlt')"
        />
        <img
          src="about-artemisads/where-will-promotion-posts-be-displayed-02.png"
          :alt="st('helpDocs.wherePosts.imgAlt')"
        />
        <img
          src="about-artemisads/where-will-promotion-posts-be-displayed-03.png"
          :alt="st('helpDocs.wherePosts.imgAlt')"
        />
        <img
          src="about-artemisads/where-will-promotion-posts-be-displayed-04.png"
          :alt="st('helpDocs.wherePosts.imgAlt')"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>

<style lang="less" scoped>
.flex {
  gap: 16px;
  padding: 16px;
  display: flex;
  margin: 0 auto;
  border-radius: 8px;
  align-items: center;
  background: var(--bg-gray-9);
  justify-content: space-between;
  > img {
    flex: 1;
    max-width: 23.5%;
    border-radius: 4px;
  }
}
</style>
